var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "\n      M4 7\n      c1.1 0 2-.9 2-2\n      h12\n      c0 1.1.9 2 2 2\n      v10\n      c-1.1 0-2 .9-2 2\n      H6\n      c0-1.1-.9-2-2-2\n      V7z\n    "
    }
  }), _c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-width": "2",
      "stroke-dasharray": "2 2",
      "d": "M12 9v6"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }